import { useMemo } from "react";
import { useSelector } from "react-redux";
import useTranslate from "hooks/useTranslate";
import useFormatBalance from "hooks/useFormatBalance";
import * as userSelector from "redux/user/selectors";

type CurrencyCode = string;
type CurrencyValueMap = Record<CurrencyCode, number>;

type UseAmountTextByCurrencyProps = {
  placeholderKey: string;
  valuesByCurrency: CurrencyValueMap;
  currencyCode?: string;
};

export function useAmountTextByCurrency({
  placeholderKey,
  valuesByCurrency,
  currencyCode,
}: UseAmountTextByCurrencyProps): string {
  const t = useTranslate();
  const reduxCurrency = useSelector(userSelector.currency);
  const userCurrencyCode = reduxCurrency?.isoCode;

  const requestedCurrency = (
    currencyCode ||
    userCurrencyCode ||
    ""
  ).toUpperCase();

  const hasValue =
    requestedCurrency && valuesByCurrency[requestedCurrency] !== undefined;
  const finalCurrency = hasValue ? requestedCurrency : "EUR";

  const formatBalance = useFormatBalance(finalCurrency);

  return useMemo(() => {
    const rawTemplate = t(placeholderKey);

    const value = valuesByCurrency[finalCurrency];
    const formattedValue =
      typeof value === "number" ? formatBalance(value * 100) : "{amount}";

    // гарантируем пробел СЛЕВА и СПРАВА от вставки
    return rawTemplate.replace(/{amount}/gi, (match, offset) => {
      const prevChar = rawTemplate[offset - 1];
      const nextChar = rawTemplate[offset + match.length];

      const leftSpace = prevChar === " " || prevChar === undefined ? "" : " ";
      const rightSpace = nextChar === " " || nextChar === undefined ? "" : " ";

      return `${leftSpace}${formattedValue}${rightSpace}`;
    });
  }, [t, placeholderKey, valuesByCurrency, finalCurrency, formatBalance]);
}
